"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCareDescription = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cotopaxi_1 = require("@as/cotopaxi");
const HtmlInclude_1 = require("../../common/html-include/HtmlInclude");
const ProductCareDescription = ({ description }) => ((0, jsx_runtime_1.jsx)(cotopaxi_1.Text, { size: cotopaxi_1.TextSize.SMALL, children: (0, jsx_runtime_1.jsx)(HtmlInclude_1.HtmlInclude, { htmlFragment: description }) }));
exports.ProductCareDescription = ProductCareDescription;
